import {
    CheckEmailQuery as SourceCheckEmailQuery
} from 'SourceQuery/CheckEmail.query';
import { Field } from 'Util/Query';

/** @namespace PeggysagePwa/Query/CheckEmail/Query */
export class CheckEmailQuery extends SourceCheckEmailQuery {
    /**
     * Override: add customer group id field
     * @param email
     * @returns {Field}
     */
    getIsEmailAvailableQuery(email) {
        const query = new Field('isEmailAvailable')
            .addArgument('email', 'String!', email)
            .addField('is_email_available');
            // .addField('customer_group_id');

        return query;
    }
}

export default new CheckEmailQuery();
